"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5476,5457,9347],{

/***/ 15457:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33616);
var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgCheckmarkCircle = function SvgCheckmarkCircle(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "CurrentColor",
    d: "M7 .333A6.667 6.667 0 1 0 13.668 7 6.674 6.674 0 0 0 7.001.333ZM7 13a6 6 0 1 1 6-6 6.006 6.006 0 0 1-6 6Z"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "CurrentColor",
    d: "M9.765 5.097 6.237 8.626a.333.333 0 0 1-.472 0L4.237 7.097a.334.334 0 0 0-.472.472l1.528 1.528a1 1 0 0 0 1.415 0l3.529-3.528a.334.334 0 1 0-.472-.472Z"
  })));
};
/* harmony default export */ __webpack_exports__["default"] = (SvgCheckmarkCircle);

/***/ }),

/***/ 53516:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33616);
var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgWarningCircle = function SvgWarningCircle(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "CurrentColor",
    d: "M7 .667A6.333 6.333 0 1 0 13.334 7 6.341 6.341 0 0 0 7 .667Zm0 12A5.666 5.666 0 1 1 12.667 7 5.673 5.673 0 0 1 7 12.667Z"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "CurrentColor",
    d: "M7 3.667A.333.333 0 0 0 6.667 4v3.996a.333.333 0 1 0 .667 0V4A.333.333 0 0 0 7 3.667ZM7 9a.333.333 0 0 1 .334.333V10a.333.333 0 1 1-.667 0v-.667A.333.333 0 0 1 7 9Z"
  })));
};
/* harmony default export */ __webpack_exports__["default"] = (SvgWarningCircle);

/***/ }),

/***/ 60652:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RQ": function() { return /* binding */ VARIANT_MAPS; },
/* harmony export */   "r4": function() { return /* binding */ SectionText; }
/* harmony export */ });
/* unused harmony export VARIANT_MAPS_TITLE */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(77215);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23097);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89136);
/* harmony import */ var common_tags__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62123);
/* harmony import */ var _atoms__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(38959);
/* harmony import */ var _atoms__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(94557);
/* harmony import */ var _atoms__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(97932);
/* harmony import */ var _atoms__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(60864);
/* harmony import */ var _atoms__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(81246);
/* harmony import */ var _atoms__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(64903);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        flex gap-8 md:mb-6 md:gap-16\n        ",
        "\n        ",
        "\n      "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n            max-w-[802px] justify-between\n            ",
        "\n            ",
        "   \n          "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n              text-heading text-heading-mobile--h2 !font-normal md:text-heading--h2 \n              ",
        "\n              ",
        "\n            "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n            flex max-w-[802px]  flex-col gap-4\n            ",
        "\n            ",
        "\n            ",
        " \n           \n          "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n                  mb-5  break-keep !text-[20px]  !font-light  leading-[28px] md:mb-6\n                  ",
        "\n                  ",
        "\n                  ",
        "\n                "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}




var TEXT_ALIGN_MAPS = {
    center: "flex md:justify-center md:text-center",
    end: "flex md:justify-end md:text-end",
    start: "flex md:justify-start md:text-start"
};
var TEXT_ALIGN_MAPS_MOBILE = {
    center: "flex justify-center text-center",
    end: "flex justify-end text-end",
    start: "flex justify-start text-start"
};
var VARIANT_MAPS = {
    primary: "text-primary-400",
    secondary: "text-secondary-400",
    alternative: "text-white"
};
var VARIANT_MAPS_TITLE = {
    primary: "!text-brownie-500",
    secondary: "text-secondary-400",
    alternative: "text-white"
};
var SectionText = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, caption = param.caption, desc = param.desc, direction = param.direction, textAlign = param.textAlign, textAlignMobile = param.textAlignMobile, title = param.title, caracteristics = param.caracteristics, variant = param.variant, _caracCols = param.caracCols, caracCols = _caracCols === void 0 ? 2 : _caracCols, directionMobile = param.directionMobile, _showSeeMore = param.showSeeMore, showSeeMore = _showSeeMore === void 0 ? false : _showSeeMore, subtitle = param.subtitle;
    var t = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("common").t;
    var rowCarac = direction === "row" && directionMobile === "row" && !caracteristics;
    var captionAlignment = direction === "column" ? textAlign === "center" ? "md:justify-center md:items-center" : textAlign === "end" ? "md:justify-end md:items-end" : "md:justify-start md:items-start" : "";
    var MobileAlignment = direction === "column" ? textAlignMobile === "center" ? "justify-center items-center" : textAlignMobile === "end" ? "justify-end items-end" : "justify-start items-start" : "";
    /* eslint-disable-next-line @typescript-eslint/ban-ts-comment */ /* @ts-ignore */ var labels = t("components.atoms.seeMore.labels", "common", {
        returnObjects: true
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
        className: (0,common_tags__WEBPACK_IMPORTED_MODULE_3__/* .oneLine */ .f9)(_templateObject(), rowCarac ? "flex-row" : "\n              ".concat(directionMobile === "row" ? "flex-row " : "flex-col", "  \n              ").concat(direction === "row" ? "justify-between md:flex-row " : "md:flex-col", "\n            "), className),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: rowCarac ? "w-full max-w-fit md:w-full" : direction === "row" ? "w-full max-w-fit md:w-1/2" : "",
                children: [
                    caption && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_atoms__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        align: textAlign,
                        className: "mb-4 ".concat(captionAlignment, " ").concat(MobileAlignment),
                        mobileAlignment: textAlignMobile !== null && textAlignMobile !== void 0 ? textAlignMobile : textAlign,
                        variant: variant,
                        children: caption
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: (0,common_tags__WEBPACK_IMPORTED_MODULE_3__/* .oneLine */ .f9)(_templateObject1(), TEXT_ALIGN_MAPS[textAlign], TEXT_ALIGN_MAPS_MOBILE[textAlignMobile !== null && textAlignMobile !== void 0 ? textAlignMobile : textAlign]),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h2", {
                            className: (0,common_tags__WEBPACK_IMPORTED_MODULE_3__/* .oneLine */ .f9)(_templateObject2(), VARIANT_MAPS_TITLE[variant], !caracteristics ? "w-full" : "sm:w-1/2"),
                            dangerouslySetInnerHTML: {
                                __html: title
                            }
                        })
                    }),
                    subtitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "mt-6",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h3", {
                            className: "text-heading text-heading--h5 ".concat(VARIANT_MAPS[variant]),
                            children: subtitle
                        })
                    })
                ]
            }),
            desc || caracteristics ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: (0,common_tags__WEBPACK_IMPORTED_MODULE_3__/* .oneLine */ .f9)(_templateObject3(), showSeeMore ? "sm:flex-col" : "sm:flex-row", rowCarac ? "w-full md:w-1/2" : "", direction === "row" && !caracteristics ? "w-full md:w-1/2" : ""),
                children: [
                    desc && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_atoms__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        condition: showSeeMore,
                        wrapper: function(children) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_atoms__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                heigthPx: 150,
                                expanded: false,
                                labels: {
                                    viewLess: labels.viewLess,
                                    viewMore: labels.viewMore
                                },
                                children: children
                            });
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_atoms__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            html: desc,
                            className: (0,common_tags__WEBPACK_IMPORTED_MODULE_3__/* .oneLine */ .f9)(_templateObject4(), !caracteristics ? "w-full" : "w-full md:w-1/2", VARIANT_MAPS[variant], TEXT_ALIGN_MAPS[textAlign])
                        })
                    }),
                    caracteristics ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: 'sm:before:content-[" "] flex w-full flex-row sm:w-1/2 sm:before:mr-5 sm:before:block sm:before:h-auto sm:before:w-px sm:before:border-l sm:before:border-primary-400 ',
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_atoms__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            className: "w-full !gap-3 text-primary-400 ",
                            xs: caracCols,
                            md: caracCols,
                            lg: caracCols,
                            children: caracteristics.map(function(child, index) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_atoms__WEBPACK_IMPORTED_MODULE_8__/* ["default"].Item */ .Z.Item, {
                                    className: "flex flex-row gap-1",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_atoms__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                            src: child.icon,
                                            width: 20,
                                            height: 20
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                            className: "text-body text-body--secondary",
                                            children: child.text
                                        })
                                    ]
                                }, index);
                            })
                        })
                    }) : null
                ]
            }) : null
        ]
    });
};
SectionText.displayName = "SectionText";


/***/ }),

/***/ 67526:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _SectionText__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(60652);

/* harmony default export */ __webpack_exports__["Z"] = (_SectionText__WEBPACK_IMPORTED_MODULE_0__/* .SectionText */ .r4);


/***/ }),

/***/ 97932:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ see_more; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(43291);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(23097);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(33616);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(89136);
// EXTERNAL MODULE: ./components/atoms/link/index.ts + 1 modules
var atoms_link = __webpack_require__(27594);
// EXTERNAL MODULE: ./components/atoms/icon/index.ts + 2 modules
var atoms_icon = __webpack_require__(64903);
// EXTERNAL MODULE: ./lib/utils/utils.tsx
var utils = __webpack_require__(52994);
;// CONCATENATED MODULE: ./components/atoms/see-more/SeeMore.tsx






/**
 * SeeMore
 */ var SeeMore = function(param) {
    var children = param.children, _expanded = param.expanded, expanded = _expanded === void 0 ? false : _expanded, _variant = param.variant, variant = _variant === void 0 ? "primary" : _variant, labels = param.labels, heigthPx = param.heigthPx, numberOfElements = param.numberOfElements, icon = param.icon, className = param.className;
    var ref = (0,react.useState)(expanded), isExpanded = ref[0], setExpanded = ref[1];
    var t = (0,useTranslation/* default */.Z)("common").t;
    var toggle = function(state) {
        setExpanded(state);
    };
    var firstChild = (0,utils/* toArray */.qo)(children)[0];
    var firstChildRef = (0,react.useRef)(null);
    var ref1 = (0,react.useState)(expanded), seeMore = ref1[0], setSeeMore = ref1[1];
    (0,react.useEffect)(function() {
        var ref;
        /* eslint-disable-next-line @typescript-eslint/ban-ts-comment */ /* @ts-ignore */ setSeeMore((firstChildRef === null || firstChildRef === void 0 ? void 0 : (ref = firstChildRef.current) === null || ref === void 0 ? void 0 : ref.clientHeight) > heigthPx);
    }, [
        firstChildRef
    ]);
    (0,react.useEffect)(function() {
        var ref;
        /* eslint-disable-next-line @typescript-eslint/ban-ts-comment */ /* @ts-ignore */ setSeeMore((firstChildRef === null || firstChildRef === void 0 ? void 0 : (ref = firstChildRef.current) === null || ref === void 0 ? void 0 : ref.clientHeight) > heigthPx);
    }, []);
    if (!labels) {
        /* eslint-disable-next-line @typescript-eslint/ban-ts-comment */ /* @ts-ignore */ labels = t("components.atoms.seeMore.labels", "common", {
            returnObjects: true
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            numberOfElements ? (0,utils/* toArray */.qo)(children).map(function(child, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "".concat(index < numberOfElements ? "h-full min-h-full min-w-full opacity-100" : isExpanded ? "h-full min-h-full min-w-full opacity-100" : "h-0 opacity-0 ", " col-span-2 transition-all duration-500 md:col-span-1"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(child.type, (0,_object_spread/* default */.Z)({}, child.props, typeof child.type === "function" ? {
                        seen: index < numberOfElements ? true : isExpanded ? true : false
                    } : {}))
                }, index);
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    maxHeight: isExpanded ? "100%" : "".concat(heigthPx, "px")
                },
                className: "relative h-full  overflow-hidden ".concat(!isExpanded && seeMore ? " after:absolute after:bottom-0 after:left-0 after:right-0 after:h-[35px] after:bg-[linear-gradient(rgb(248_247_246/30%)_0%,#fff7f3_100%)] after:content-['']" : ""),
                children: firstChild && /*#__PURE__*/ react.cloneElement(firstChild, {
                    ref: firstChildRef
                })
            }),
            (children === null || children === void 0 ? void 0 : children.length) > numberOfElements || seeMore ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "z-10 col-start-1 col-end-[-1] mt-2 flex w-full cursor-pointer flex-row items-center justify-center gap-2 ".concat(className),
                onClick: function() {
                    return toggle(!isExpanded);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_link/* default */.Z, {
                        as: "span",
                        variant: variant,
                        arrow: false,
                        children: isExpanded ? labels === null || labels === void 0 ? void 0 : labels.viewLess : labels === null || labels === void 0 ? void 0 : labels.viewMore
                    }),
                    icon ? /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_icon/* default */.Z, {
                        className: isExpanded ? "rotate-180" : "",
                        height: 10,
                        width: 10,
                        src: icon
                    }) : null
                ]
            }) : null
        ]
    });
};
SeeMore.displayName = "SeeMore";

;// CONCATENATED MODULE: ./components/atoms/see-more/index.ts

/* harmony default export */ var see_more = (SeeMore);


/***/ }),

/***/ 74637:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ atoms_select; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(43291);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(57239);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(23097);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(33616);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(42667);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(89136);
;// CONCATENATED MODULE: ./components/atoms/select/Select.tsx






/**
 * Select
 */ var Select = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _elements = param.elements, elements = _elements === void 0 ? [] : _elements, name = param.name, defaultValue = param.defaultValue, label = param.label, requiredMessage = param.requiredMessage;
    var ref = (0,index_esm/* useFormContext */.Gc)(), register = ref.register, errors = ref.formState.errors;
    var t = (0,useTranslation/* default */.Z)("common").t;
    var elemntIndex = elements.findIndex(function(elemt) {
        return (defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.value) === elemt.value.toString();
    });
    var selectValidation = function(value) {
        return value !== "-1" || "Please select a valid option";
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                htmlFor: name,
                className: "text-other--label-form uppercase",
                children: label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                id: name
            }, register(name, (0,_object_spread/* default */.Z)({}, requiredMessage !== undefined ? {
                required: requiredMessage,
                validate: selectValidation
            } : {
                required: requiredMessage
            }))), {
                name: name,
                defaultValue: elemntIndex !== -1 ? defaultValue ? defaultValue.value : 0 : elemntIndex,
                className: "text-body ".concat(errors[name] ? "border-[#ff0000] text-[#ff0000] placeholder-[#ff0000]" : "text-body--primary border-primary-400 text-primary-400 placeholder-primary-400", "   w-full cursor-pointer border-b  bg-transparent pb-2  outline-none ").concat(className),
                children: [
                    defaultValue && elemntIndex === -1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                        value: defaultValue.value,
                        children: defaultValue.label
                    }) : null,
                    elements === null || elements === void 0 ? void 0 : elements.map(function(child, index) {
                        return /*#__PURE__*/ (0,react.createElement)("option", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, child.disabled && {
                            disabled: true
                        }), {
                            className: "w-full",
                            key: index,
                            value: child.value,
                            children: [
                                child.label,
                                child.disabled ? t("components.atoms.select.soon") : ""
                            ]
                        }));
                    })
                ]
            })),
            errors[name] && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "text-other--detail text-[#ff0000]",
                children: errors[name].message
            })
        ]
    });
};
Select.displayName = "Select";

;// CONCATENATED MODULE: ./components/atoms/select/index.ts

/* harmony default export */ var atoms_select = (Select);


/***/ }),

/***/ 5476:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ templates_contact_form; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(43291);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(57239);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(23097);
// EXTERNAL MODULE: ./components/atoms/container/index.ts + 1 modules
var container = __webpack_require__(82112);
// EXTERNAL MODULE: ./components/atoms/section-text/index.ts
var section_text = __webpack_require__(67526);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(36045);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(74772);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(33616);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(42667);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(89136);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(60123);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(96052);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/atoms/grid/index.ts + 2 modules
var grid = __webpack_require__(81246);
;// CONCATENATED MODULE: ./components/atoms/input/Input.tsx




/**
 * Input
 */ var Input = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, placeholder = param.placeholder, type = param.type, name = param.name, requiredMessage = param.requiredMessage, label = param.label;
    var ref = (0,index_esm/* useFormContext */.Gc)(), register = ref.register, errors = ref.formState.errors;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col gap-2",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                htmlFor: name,
                className: "text-other--label-form uppercase",
                children: label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                id: name,
                placeholder: placeholder,
                type: type
            }, register(name, {
                required: requiredMessage
            })), {
                className: "text-body  text-body--primary border-b bg-transparent pb-2 font-light outline-none ".concat(errors[name] ? "border-[#ff0000] text-[#ff0000] placeholder-[#ff0000]" : "border-primary-400 text-primary-400 placeholder-primary-400", "  ").concat(className)
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "text-other--detail text-[#ff0000] ".concat(errors[name] ? "block" : "hidden"),
                children: requiredMessage
            })
        ]
    });
};
Input.displayName = "Input";

;// CONCATENATED MODULE: ./components/atoms/input/index.ts

/* harmony default export */ var input = (Input);

// EXTERNAL MODULE: ./components/atoms/select/index.ts + 1 modules
var atoms_select = __webpack_require__(74637);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(77215);
// EXTERNAL MODULE: ./node_modules/common-tags/es/index.js + 40 modules
var es = __webpack_require__(62123);
;// CONCATENATED MODULE: ./components/atoms/text-area/TextArea.tsx



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          max-h-96 w-full resize-y border-b bg-transparent font-light outline-none\n          ",
        "\n          ",
        "\n        "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          text-other--detail text-[#ff0000]\n          ",
        "\n        "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



/**
 * TextArea
 */ var TextArea = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _rows = param.rows, rows = _rows === void 0 ? 3 : _rows, label = param.label, name = param.name, requiredMessage = param.requiredMessage, placeholder = param.placeholder;
    var ref = (0,index_esm/* useFormContext */.Gc)(), register = ref.register, errors = ref.formState.errors;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                htmlFor: name,
                className: "text-other--label-form uppercase",
                children: label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, register(name, {
                required: requiredMessage
            })), {
                name: name !== null && name !== void 0 ? name : "description",
                rows: rows
            }), placeholder && {
                placeholder: placeholder
            }), {
                id: name,
                className: (0,es/* oneLine */.f9)(_templateObject(), errors[name] ? "border-[#ff0000] text-[#ff0000] placeholder-[#ff0000]" : "border-primary-400 text-primary-400 placeholder-primary-400", className)
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (0,es/* oneLine */.f9)(_templateObject1(), errors[name] ? "block" : "hidden"),
                children: requiredMessage
            })
        ]
    });
};
TextArea.displayName = "TextArea";

;// CONCATENATED MODULE: ./components/atoms/text-area/index.ts

/* harmony default export */ var text_area = (TextArea);

;// CONCATENATED MODULE: ./components/atoms/checkbox/Checkbox.tsx



function Checkbox_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n             cursor-pointer\n            ",
        "\n          "
    ]);
    Checkbox_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Checkbox_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          text-other--detail text-[#ff0000]\n          ",
        "\n        "
    ]);
    Checkbox_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



/**
 * Checkbox
 */ var Checkbox = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, text = param.text, name = param.name, requiredMessage = param.requiredMessage;
    var ref = (0,index_esm/* useFormContext */.Gc)(), register = ref.register, errors = ref.formState.errors;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col gap-2 ".concat(className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex gap-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "h-5 min-w-[15px]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                            className: (0,es/* oneLine */.f9)(Checkbox_templateObject(), errors[name] ? "border-[#ff0000]" : "accent-primary-400")
                        }, register(name, {
                            required: requiredMessage
                        })), {
                            type: "checkbox",
                            id: name
                        }))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                        className: "text-other text-other--detail cursor-pointer ".concat(errors[name] ? "text-[#ff0000] " : "text-primary-400"),
                        htmlFor: name,
                        children: text
                    })
                ]
            }),
            errors[name] && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (0,es/* oneLine */.f9)(Checkbox_templateObject1(), errors[name] ? "block" : "hidden"),
                children: requiredMessage
            })
        ]
    });
};
Checkbox.displayName = "Checkbox";

;// CONCATENATED MODULE: ./components/atoms/checkbox/index.ts

/* harmony default export */ var atoms_checkbox = (Checkbox);

// EXTERNAL MODULE: ./components/atoms/button/index.ts + 1 modules
var atoms_button = __webpack_require__(60825);
// EXTERNAL MODULE: ./components/atoms/prose/index.ts + 1 modules
var prose = __webpack_require__(60864);
// EXTERNAL MODULE: ./public/assets/icons/CheckmarkCircle.svg
var CheckmarkCircle = __webpack_require__(15457);
// EXTERNAL MODULE: ./public/assets/icons/WarningCircle.svg
var WarningCircle = __webpack_require__(53516);
// EXTERNAL MODULE: ./lib/utils/gtm/helpers.ts
var helpers = __webpack_require__(47675);
;// CONCATENATED MODULE: ./components/organisms/contact-form/ContactForm.tsx














var PhoneInput = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(8238), __webpack_require__.e(4752)]).then(__webpack_require__.bind(__webpack_require__, 34752));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(34752)
            ];
        }
    },
    ssr: false
});
var PopUp = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5518), __webpack_require__.e(3117)]).then(__webpack_require__.bind(__webpack_require__, 53117));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(53117)
            ];
        }
    },
    ssr: false
});
/**
 * ContactForm
 */ var ContactForm = function(param) {
    var textPolicies = param.textPolicies, buildingSelect = param.buildingSelect, accommodationSelect = param.accommodationSelect, hearUsSelect = param.hearUsSelect, className = param.className, _landing = param.landing, landing = _landing === void 0 ? false : _landing, defaultBuilding = param.defaultBuilding, defaultApartment = param.defaultApartment, hearUsDefaultValue = param.hearUsDefaultValue;
    var ref = (0,useTranslation/* default */.Z)("common"), t = ref.t, lang = ref.lang;
    var buildingsSelectValues = buildingSelect.map(function(building) {
        return {
            label: building.label,
            value: building.id,
            disabled: building.disabled
        };
    });
    var mapOfAccommodation = new Map(accommodationSelect);
    var methods = (0,index_esm/* useForm */.cI)();
    var watchBuilding = methods.watch("building", buildingsSelectValues[0].value.toString());
    var ref1 = (0,react.useState)(false), showModal = ref1[0], setShowModal = ref1[1];
    var ref2 = (0,react.useState)(false), hasError = ref2[0], setHasError = ref2[1];
    var Icon = hasError ? WarningCircle["default"] : CheckmarkCircle["default"];
    var close = function() {
        setShowModal(false);
        setHasError(false);
    };
    var onSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var isMobilePhone, valid, selectedBuilding, ref, response, body, _tmp, _tmp1, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            __webpack_require__.e(/* import() */ 5340).then(__webpack_require__.bind(__webpack_require__, 75340))
                        ];
                    case 1:
                        isMobilePhone = _state.sent().default;
                        valid = isMobilePhone((data === null || data === void 0 ? void 0 : data.telephone) ? data === null || data === void 0 ? void 0 : data.telephone : "123");
                        if (!valid) {
                            methods.setError("telephone", {
                                type: "custom",
                                message: t("components.organisms.contactForm.phoneError")
                            });
                            return [
                                2
                            ];
                        }
                        if (!(data.email !== data.emailConfirm)) return [
                            3,
                            2
                        ];
                        methods.setError("emailConfirm", {
                            type: "custom",
                            message: t("components.organisms.contactForm.emailError")
                        });
                        return [
                            2
                        ];
                    case 2:
                        _state.trys.push([
                            2,
                            11,
                            ,
                            12
                        ]);
                        selectedBuilding = buildingSelect.find(function(building) {
                            return building.id.toString() === data.building;
                        });
                        return [
                            4,
                            fetch("/api/lavanda", {
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/json"
                                },
                                body: JSON.stringify({
                                    name: data.name,
                                    lastName: data.lastName,
                                    email: data.email,
                                    phone: "+".concat(data.telephone),
                                    description: (ref = data === null || data === void 0 ? void 0 : data.addMore) !== null && ref !== void 0 ? ref : "No se ha a\xf1adido descripci\xf3n",
                                    marketingOptIn: data.checkboxNotMandatory,
                                    gdprConsent: true,
                                    hearUs: data.hearUs,
                                    building: {
                                        name: selectedBuilding === null || selectedBuilding === void 0 ? void 0 : selectedBuilding.label,
                                        id: selectedBuilding === null || selectedBuilding === void 0 ? void 0 : selectedBuilding.endpointId
                                    },
                                    typeOfApartment: data.accommodation
                                })
                            })
                        ];
                    case 3:
                        response = _state.sent();
                        return [
                            4,
                            response.json()
                        ];
                    case 4:
                        body = _state.sent();
                        if (!response.ok) return [
                            3,
                            9
                        ];
                        _tmp = {
                            event: "generate_lead",
                            lead_type: "contact",
                            provincia: ""
                        };
                        return [
                            4,
                            (0,helpers/* sha256 */.JQ)("+".concat(data.telephone))
                        ];
                    case 5:
                        _tmp.phone_number = _state.sent(), _tmp.edificio = selectedBuilding === null || selectedBuilding === void 0 ? void 0 : selectedBuilding.label, _tmp.tipo_de_apartamento = data.accommodation, _tmp.conocido = data.hearUs;
                        _tmp1 = {};
                        return [
                            4,
                            (0,helpers/* sha256 */.JQ)(data.name)
                        ];
                    case 6:
                        _tmp1.first_name = _state.sent();
                        return [
                            4,
                            (0,helpers/* sha256 */.JQ)(data.lastName)
                        ];
                    case 7:
                        _tmp.address = (_tmp1.last_name = _state.sent(), _tmp1);
                        return [
                            4,
                            (0,helpers/* sha256 */.JQ)(data.email)
                        ];
                    case 8:
                        helpers/* gtmPush.apply */.De.apply(void 0, [
                            (_tmp.email = _state.sent(), _tmp)
                        ]);
                        setShowModal(true);
                        methods.clearErrors();
                        methods.reset();
                        return [
                            3,
                            10
                        ];
                    case 9:
                        throw new Error(JSON.stringify(body));
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        e = _state.sent();
                        setHasError(true);
                        setShowModal(true);
                        return [
                            3,
                            12
                        ];
                    case 12:
                        return [
                            2
                        ];
                }
            });
        });
        return function onSubmit(data) {
            return _ref.apply(this, arguments);
        };
    }();
    var ref3;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FormProvider */.RV, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, methods), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                    className: "\n          relative mt-6 flex w-full flex-col gap-4 rounded-md bg-white p-6 pt-10 shadow-md lg:p-16 \n          ".concat(landing ? "lg:w-2/5" : "", "\n          ").concat(className, "\n        "),
                    onSubmit: methods.handleSubmit(onSubmit),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "".concat(landing ? "flex flex-row items-center justify-center" : "absolute left-0 top-0 -mt-8 ml-6 lg:ml-16"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: "/assets/img/logo/logo-brown.svg",
                                alt: "logo",
                                width: 68,
                                height: 68,
                                className: "object-contain"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(grid/* default */.Z, {
                            xs: 1,
                            md: 1,
                            lg: 2,
                            className: "!gap-8",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(grid/* default.Item */.Z.Item, {
                                    colSpanLG: landing ? 2 : 1,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(input, {
                                        label: t("components.organisms.contactForm.nameLabel"),
                                        requiredMessage: t("components.organisms.contactForm.requiredMessage"),
                                        name: "name",
                                        type: "text",
                                        placeholder: t("components.organisms.contactForm.namePlaceholder")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(grid/* default.Item */.Z.Item, {
                                    colSpanLG: landing ? 2 : 1,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(input, {
                                        label: t("components.organisms.contactForm.lastNameLabel"),
                                        name: "lastName",
                                        type: "text",
                                        placeholder: t("components.organisms.contactForm.lastNamePlaceholder"),
                                        requiredMessage: t("components.organisms.contactForm.requiredMessage")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(grid/* default.Item */.Z.Item, {
                                    colSpanLG: landing ? 2 : 1,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(input, {
                                        label: t("components.organisms.contactForm.emailLabel"),
                                        name: "email",
                                        type: "email",
                                        placeholder: t("components.organisms.contactForm.emailPlaceholder"),
                                        requiredMessage: t("components.organisms.contactForm.requiredMessage")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(grid/* default.Item */.Z.Item, {
                                    colSpanLG: landing ? 2 : 1,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(input, {
                                        label: t("components.organisms.contactForm.emailConfirmLabel"),
                                        name: "emailConfirm",
                                        type: "email",
                                        placeholder: t("components.organisms.contactForm.emailPlaceholder"),
                                        requiredMessage: t("components.organisms.contactForm.emailConfirmationRequiredMessage")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(grid/* default.Item */.Z.Item, {
                                    colSpanLG: landing ? 2 : 1,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PhoneInput, {
                                        label: t("components.organisms.contactForm.phoneLabel"),
                                        name: "telephone",
                                        language: lang === "es" ? "es" : "eng",
                                        requiredMessage: t("components.organisms.contactForm.requiredMessage"),
                                        className: "h-full"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(grid/* default.Item */.Z.Item, {
                                    colSpanLG: landing ? 2 : 1,
                                    className: landing ? "order-last" : "",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_select/* default */.Z, (0,_object_spread/* default */.Z)({
                                        label: t("components.organisms.contactForm.hearAboustUs"),
                                        name: "hearUs",
                                        defaultValue: hearUsDefaultValue
                                    }, hearUsSelect))
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(grid/* default.Item */.Z.Item, {
                                    colSpanLG: landing ? 2 : 1,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_select/* default */.Z, {
                                        label: t("components.organisms.contactForm.buildingLabel"),
                                        name: "building",
                                        requiredMessage: t("components.organisms.contactForm.requiredMessage"),
                                        elements: buildingsSelectValues,
                                        defaultValue: defaultBuilding
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(grid/* default.Item */.Z.Item, {
                                    colSpanLG: landing ? 2 : 1,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_select/* default */.Z, {
                                        label: t("components.organisms.contactForm.accommodationLabel"),
                                        name: "accommodation",
                                        defaultValue: defaultApartment,
                                        elements: (ref3 = mapOfAccommodation.get(parseInt(watchBuilding === null || watchBuilding === void 0 ? void 0 : watchBuilding.toString()))) !== null && ref3 !== void 0 ? ref3 : []
                                    })
                                }),
                                !landing && /*#__PURE__*/ (0,jsx_runtime.jsx)(grid/* default.Item */.Z.Item, {
                                    colSpanLG: 2,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(text_area, {
                                        label: t("components.organisms.contactForm.addMore"),
                                        rows: 5,
                                        name: "addMore",
                                        placeholder: t("components.organisms.contactForm.addMorePlaceholder")
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex w-full flex-col justify-around gap-3",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "mb-1 text-[9px] uppercase tracking-wider",
                                    children: t("components.organisms.contactForm.obligatoryFields")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_checkbox, {
                                    text: t("components.organisms.contactForm.checkboxPolicy"),
                                    name: "checkboxMandatory"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_checkbox, {
                                    text: t("components.organisms.contactForm.checkboxSubscription"),
                                    name: "checkboxNotMandatory"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_button/* default */.Z, {
                            type: "submit",
                            size: "large",
                            variant: "primary",
                            className: "md:ml-auto md:max-w-max",
                            children: t("components.organisms.contactForm.sendButton")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(prose/* default */.Z, {
                            html: textPolicies,
                            className: "text-other--detail text-xs leading-4 !text-primary-200"
                        })
                    ]
                })
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PopUp, {
                state: showModal,
                funcionOnClose: close,
                className: "bg-surface-01 text-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex max-w-md flex-col items-center justify-center gap-8",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                            width: "57",
                            className: hasError ? "text-status-error" : "text-status-success"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-heading-mobile--h3 mb-4 lg:text-heading-mobile--h2",
                                    children: hasError ? t("components.organisms.contactForm.popUp.error.title") : t("components.organisms.contactForm.popUp.sucess.title")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-body--primary",
                                    children: hasError ? t("components.organisms.contactForm.popUp.error.desc") : t("components.organisms.contactForm.popUp.sucess.desc")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_button/* default */.Z, {
                            size: "small",
                            variant: "secondary",
                            onClick: close,
                            className: "max-w-max",
                            children: hasError ? t("components.organisms.contactForm.popUp.error.button") : t("components.organisms.contactForm.popUp.sucess.button")
                        })
                    ]
                })
            })
        ]
    });
};
ContactForm.displayName = "ContactForm";

;// CONCATENATED MODULE: ./components/organisms/contact-form/index.ts

/* harmony default export */ var contact_form = (ContactForm);

;// CONCATENATED MODULE: ./components/templates/contact-form/ContactForm.tsx





/**
 * ContactForm
 */ var ContactForm_ContactForm = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, caption = param.caption, formValues = param.formValues, title = param.title, landing = param.landing, background = param.background, desc = param.desc, index = param.index, textColor = param.textColor, id = param.id;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
                scoped: true,
                children: "\n    .backimage {\n      background-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)), url(".concat(background.backgroundImageMobile, ");\n      background-size: cover ;\n          \n    }\n  \n  @media (min-width: 750px) {\n    .backimage {\n      background-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)), url(").concat(background.backgroundImage, ") !important;\n      background-size: cover !important;\n    }\n  }")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "backimage",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(container/* default */.Z, {
                    id: id,
                    index: index,
                    backgroundColorBottom: background.backgroundColorBottom,
                    backgroundColorTop: background.backgroundColorTop,
                    backgroundColorBottomMobile: background.backgroundColorBottomMobile,
                    backgroundColorTopMobile: background.backgroundColorTopMobile,
                    cutLevel: background.cutLevel,
                    cutLevelMobile: background.cutLevelMobile,
                    hasCutLevel: background.hasCutLevel,
                    className: "!py-14  lg:!py-20 ".concat(landing ? "flex w-full  !max-w-none flex-col !py-4 md:!py-20 md:pr-4 lg:flex-row" : "flex flex-col gap-5", " ").concat(className),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(section_text/* default */.Z, {
                            direction: "column",
                            textAlign: landing ? "start" : "center",
                            textAlignMobile: "start",
                            variant: textColor,
                            caption: caption,
                            title: title,
                            className: "".concat(landing ? "w-full justify-center p-16 lg:[&>div>div>h2]:text-heading--h1 lg:w-3/5" : "items-center"),
                            desc: desc
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(contact_form, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formValues), {
                            landing: landing
                        }))
                    ]
                })
            })
        ]
    });
};
ContactForm_ContactForm.displayName = "ContactForm";

;// CONCATENATED MODULE: ./components/templates/contact-form/index.ts

/* harmony default export */ var templates_contact_form = (ContactForm_ContactForm);


/***/ }),

/***/ 47675:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "De": function() { return /* binding */ gtmPush; },
/* harmony export */   "JQ": function() { return /* binding */ sha256; }
/* harmony export */ });
/* unused harmony export debugGtm */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36045);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74772);


var debugGtm = function(debugMsg, data) {
    var isProd = "production" === "production";
    // eslint-disable-next-line no-console
    if (!isProd) console.log("".concat(debugMsg, ": "), data);
};
var gtmPush = function(data) {
    var // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    ref;
    (ref = window.dataLayer) === null || ref === void 0 ? void 0 : ref.push(data);
    debugGtm("GTM PUSH", data);
};
function sha256(message) {
    return _sha256.apply(this, arguments);
}
function _sha256() {
    _sha256 = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(message) {
        var msgUint8, hashBuffer, hashArray, hashHex;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    msgUint8 = new TextEncoder().encode(message); // encode as (utf-8) Uint8Array
                    return [
                        4,
                        crypto.subtle.digest("SHA-256", msgUint8)
                    ];
                case 1:
                    hashBuffer = _state.sent();
                    hashArray = Array.from(new Uint8Array(hashBuffer)); // convert buffer to byte array
                    hashHex = hashArray.map(function(b) {
                        return b.toString(16).padStart(2, "0");
                    }).join(""); // convert bytes to hex string
                    return [
                        2,
                        hashHex
                    ];
            }
        });
    });
    return _sha256.apply(this, arguments);
}


/***/ }),

/***/ 36045:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _asyncToGenerator; }
/* harmony export */ });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}


/***/ })

}]);